module.exports = __webpack_public_path__ + "img/tpc-web-9.72f3dbcf.webp";